import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import {routerUrls} from '../utils/helpers/urlHelper.mjs';
import {useGuideConfig} from '../hooks/useGuideConfig.js';
import {usePages} from '../hooks/index.mjs';
import {PAGE_TYPES} from '../state/index.mjs';

/**
 * A wrapper component that will only render children if criteria is matched
 */
const RenderOnlyFor = ({ children, forDetailsPage, forLandingPage, forSummaryPage, forSurveyPage, whenBranchGuide, whenMockMode, whenDemoMode }) => {
  const { isBranchGuide, isMockMode, isDemoMode } = useGuideConfig();
  const { currentPageType } = usePages();

  const validGuideType = whenBranchGuide === undefined || whenBranchGuide === isBranchGuide;
  const validMockMode = whenMockMode === undefined || whenMockMode === isMockMode;
  const validDemoMode = whenDemoMode === undefined || whenDemoMode === isDemoMode;

  const hasValidPageRoutes = () => {
    const validForAnyPage = forSurveyPage === undefined &&
      forLandingPage === undefined &&
      forDetailsPage === undefined &&
      forSummaryPage === undefined;
    const landingPageMatch = useRouteMatch({ path: routerUrls.landing, isExact: true });
    const validForDetails = !!( forDetailsPage && (useRouteMatch(routerUrls.details) || isDemoMode && currentPageType === PAGE_TYPES.detailsPage) );
    const validForLanding = !!( forLandingPage && (landingPageMatch?.isExact || isDemoMode && currentPageType === PAGE_TYPES.landingPage) );
    const validForSummary = !!( forSummaryPage && (useRouteMatch(routerUrls.summary) || isDemoMode && currentPageType === PAGE_TYPES.summaryPage) );
    const validForSurvey = !!( forSurveyPage && (useRouteMatch(routerUrls.survey) || isDemoMode && currentPageType === PAGE_TYPES.surveyPage) );
    return validForDetails || validForLanding || validForSummary || validForSurvey || validForAnyPage;
  };

  return hasValidPageRoutes() && validMockMode && validGuideType && validDemoMode ? <>{ children }</> : null;
};

RenderOnlyFor.propTypes = {
  children: PropTypes.any.isRequired,
  forDetailsPage: PropTypes.bool,
  forLandingPage: PropTypes.bool,
  forSummaryPage: PropTypes.bool,
  forSurveyPage: PropTypes.bool,
  whenBranchGuide: PropTypes.bool,
  whenDemoMode: PropTypes.bool,
  whenMockMode: PropTypes.bool
};
export default RenderOnlyFor;
